const textDefaults = {
	'EN': {
		'next': 'next',
		'previous': 'previous',
		'submit': 'submit',
	},
	'FR': {
		'next': 'suivant',
		'previous': 'précédent',
		'submit': 'soumettre',
	},
	'NL': {
		'next': 'volgende',
		'previous': 'vorige',
		'submit': 'verzenden',
	},
	'DE': {
		'next': 'weiter',
		'previous': 'zurück',
		'submit': 'absenden',
	},
	'PL': {
		'next': 'dalej',
		'previous': 'poprzedni',
		'submit': 'Wyślij',
	},
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults.EN;
}